﻿import * as React from "react";
import { List, ListItem, ListItemText } from "@material-ui/core";

export interface IApplicationGroup {
    groupID: number;
    groupName: string;
    publishDate: string;
    subApplications: number;
    readLatest: boolean;
    iconResourceName: string;
    iconResourceFolder: string;
}

interface IApplicationGroupProps {
    groups: IApplicationGroup[];
    selectedGroup: number;
    collapseGroups: boolean;
    handleGroupClick: (groupID) => void;
}

export const ApplicationGroups: React.FunctionComponent<
    IApplicationGroupProps
> = (props): React.ReactElement => {
    let groupList;

    if (props.groups != null) {
        groupList = props.groups.map((group) => (
            <div key={group.groupID}>
                <ListItem
                    button={true}
                    className={`releasenotes-listitem`}
                    disableRipple={true}
                    key={group.groupID}
                    onClick={(): void => props.handleGroupClick(group.groupID)}
                    selected={props.selectedGroup === group.groupID}
                >
                    {props.collapseGroups ? (
                        group.readLatest ? (
                            <span>
                                <img
                                    src={`/Images/Icon?icon=${group.iconResourceName}&folder=${group.iconResourceFolder}`}
                                    width={`26px`}
                                />
                            </span>
                        ) : (
                            <div className={`releasenotes-flexrow`}>
                                <span>
                                    <img
                                        src={`/Images/Icon?icon=${group.iconResourceName}&folder=${group.iconResourceFolder}`}
                                        width={`26px`}
                                    />
                                </span>
                                <span
                                    className={
                                        props.selectedGroup === group.groupID
                                            ? `releasenotes-readlatest selected`
                                            : `releasenotes-readlatest`
                                    }
                                    style={{
                                        marginLeft: `3px`,
                                    }}
                                />
                            </div>
                        )
                    ) : (
                        <ListItemText
                            disableTypography={true}
                            primary={
                                group.readLatest ? (
                                    <div
                                        className={`releasenotes-list-primary`}
                                    >
                                        {group.groupName}
                                    </div>
                                ) : (
                                    <div
                                        className={`releasenotes-list-primary`}
                                    >
                                        <span>{group.groupName}</span>
                                        <span
                                            className={
                                                props.selectedGroup ===
                                                group.groupID
                                                    ? `releasenotes-readlatest selected`
                                                    : `releasenotes-readlatest`
                                            }
                                        />
                                    </div>
                                )
                            }
                            secondary={
                                <div className={`releasenotes-list-secondary`}>
                                    <div>{`Last updated: ${group.publishDate.substr(
                                        0,
                                        10,
                                    )}`}</div>
                                    <div>{`${group.subApplications} Sub Applications`}</div>
                                </div>
                            }
                        />
                    )}
                </ListItem>
                {props.collapseGroups ? (
                    ``
                ) : (
                    <div className={`releasenotes-linebreak`} />
                )}
            </div>
        ));
    } else {
        groupList = (
            <ListItem>
                <ListItemText primary={`Loading`} secondary={``} />
            </ListItem>
        );
    }

    return <List className={`releasenotes-scrollable`}>{groupList}</List>;
};
